<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Adicionar unidade de negócio no cliente
                </h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entity">
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="col-form-label">Cliente</label>
                                <div>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">{{cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                        </div>                                        
                                        <input type="text" class="form-control" [value]="createNomeCliente()" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text text-muted nome-fantasia-cnpj-cpf">
                                        {{cliente?.pessoa?.nomeFantasia}} - {{cliente?.pessoa?.cnpjCpf}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="unidadeNegocioInsert" class="col-form-label">Unidade de Negócio</label>
                                <select class="form-control" name="unidadeNegocioInsert" id="unidadeNegocioInsert"
                                    [ngModel]="entity.idUnidadeNegocio || ''" (ngModelChange)="onSelectUnidadeNegocio($event ? $event : null)"
                                    #unidadeNegocioInsert="ngModel" required="required">
                                    <option value="">Selecione a unidade de negócio...</option>
                                    <option *ngFor="let unidade of unidadesNegocio" [ngValue]="unidade.id">{{unidade.nome}}</option>
                                </select>
                                <sgt-form-control-error
                                    *ngIf="unidadeNegocioInsert.errors && unidadeNegocioInsert.errors.required && unidadeNegocioInsert.dirty"
                                    msgError="A unidade de negócio é obrigatória">
                                </sgt-form-control-error>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="unidadeNegocioInsertMercado" class="col-form-label">Mercado</label>
                                <select class="form-control" name="unidadeNegocioInsertMercado" id="unidadeNegocioInsertMercado"
                                    [ngModel]="entity.idMercado || ''" (ngModelChange)="entity.idMercado = $event ? $event : null"
                                    #unidadeNegocioInsertMercado="ngModel" [required]="mercadoRequired">
                                    <option value="">Nenhum mercado</option>
                                    <option *ngFor="let unidadeNegocioMercado of mercados" [ngValue]="unidadeNegocioMercado.idMercado">{{unidadeNegocioMercado.mercado?.nome}}</option>
                                </select>
                            </div>                            
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="unidadeNegocioInsertNaturezaVenda" class="col-form-label">Natureza de Venda</label>
                                <select class="form-control" name="unidadeNegocioInsertNaturezaVenda" id="unidadeNegocioInsertNaturezaVenda"
                                    [ngModel]="entity.idNaturezaVenda || ''" (ngModelChange)="entity.idNaturezaVenda = $event ? $event : null"
                                    #unidadeNegocioInsertNaturezaVenda="ngModel" [required]="naturezaVendaRequired">
                                    <option value="">Nenhuma natureza de venda</option>
                                    <option *ngFor="let unidadeNegocioNaturezaVenda of naturezasVendas" [ngValue]="unidadeNegocioNaturezaVenda.idNaturezaVenda">{{unidadeNegocioNaturezaVenda.naturezaVenda?.nome}}</option>
                                </select>
                            </div>                            
                        </div> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="unidadeNegocioInsertItemTipo" class="col-form-label">Tipo de Produto</label>
                                <select class="form-control" name="unidadeNegocioInsertItemTipo" id="unidadeNegocioInsertItemTipo"
                                    [ngModel]="entity.idItemTipo || ''" (ngModelChange)="entity.idItemTipo = $event ? $event : null"
                                    #unidadeNegocioInsertItemTipo="ngModel" [required]="itemTipoRequired">
                                    <option value="">Nenhum Tipo de Produto</option>
                                    <option *ngFor="let itemTipo of itensTipos" [ngValue]="itemTipo.id">{{itemTipo.nome}}</option>
                                </select>
                            </div>                             
                        </div>                        
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" [disabled]="!form.valid" (click)="save()" id="btnInsertSave">
                    Adicionar
                </button>
            </div>
        </div>
    </div>
</div>
